<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<dialog-titlebar [title]="itemType.pluralDisplay"></dialog-titlebar>

<div mat-dialog-content>
	<app-item-list [itemType]="itemType" [itemList]="getItemListObservable() | async" [editor]="self">
		<!-- itemCreator:  injecting add item panel -->
		<add-edit-role
			itemCreator
			*ngIf="inAddItem"
			(memberCommitEvent)="inAddItem = !completeAdd($event)"
			[rolesApi]="rolesApi"
			[palette]="getItemPaletteColors() | async"
			[editorMode]="editorMode"
			[usedColors]="getUsedColors() | async"
			[isAdd]="true"
		>
		</add-edit-role>

		<!-- itemEditor:  injecting edit item panel -->
		<add-edit-role
			itemEditor
			*ngIf="itemInEdit"
			[item]="itemInEdit"
			[editorMode]="editorMode"
			[rolesApi]="rolesApi"
			(memberCommitEvent)="completeEdit($event) ? (itemInEdit = null) : undefined"
			[palette]="getItemPaletteColors() | async"
			[usedColors]="getUsedColors() | async"
		>
		</add-edit-role>
	</app-item-list>
</div>
